<template>
  <div class="app flex-row align-items-center" v-if="invite">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6" sm="8">
          <b-card no-body class="mx-4">
            <b-card-body class="p-4">
              <b-form v-if="invite.user_uuid == ''">
                <h1>{{ $t('acceptInvite') }}</h1>
                <p class="text-muted"></p>

                 <InputField name="name" type="text" :label="this.$t('name')" v-model="name" @error="fieldError"
                      :rules="{required:true, length: {min: 2}}"
                    />

                  <InputField name="password" type="password" :label="this.$t('password')" v-model="password" @error="fieldError"
                      :rules="{required:true, length: {min: 2}}"
                    />

                  <InputField name="confirm_password" type="password" :label="this.$t('confirmPassword')" v-model="confirm_password" @error="fieldError"
                      :rules="{required:true, length: {min: 7}}"
                    />


                <b-button variant="success" @click="acceptRegister" block>{{ $t('register') }}</b-button>
              </b-form>

              <b-button variant="success" @click="acceptInvite" block v-else>{{ $t('acceptInvite') }}</b-button>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import IdentityFields from "@/components/identityFields/IdentityFields"
import Input from "@/components/form/Input"

export default {
  components: {
    IdentityFields,
    InputField: Input
  },
  name: 'ProjectInvite',
  data: function() {
    return {
      name: "",
      password: "",
      confirm_password: "",
      invite: null
    }
  },
  methods: {
    onError(errors) {
      this.errors = errors
    },

    acceptRegister() {
        this.$http.post("/v1/project/invite/register/" + this.$route.params.uuid, {password: this.password, name: this.name}).then(resp => {
            if (resp.status == 200) {
              window.location = "/login"
            }

            if (resp.status == 400) {
              this.$mainDialog.msgBoxOk(this.$t('registeredUser')).then(resp => {
                window.location.reload()
              })
            }
        }).catch(error => {
          if (error.response.status == 500) {
            this.$serverErrorModal(error)
            return
          }

          this.$mainDialog.msgBoxOk(error.response.data.message)
        })
    },

    acceptInvite() {
        this.$http.get("/v1/project/invite/accept/" + this.$route.params.uuid).then(resp => {
            if (resp.status == 200) {
                window.location = "/login"
            }
        }).catch(error => {
          if (error.response.status == 500) {
            this.$serverErrorModal(error)
            return
          }

          this.$mainDialog.msgBoxOk(error.response.data.message)
        })
    }
  },
  mounted() {
      this.$http.get("/v1/project/invite/" + this.$route.params.uuid).then(resp => {
          this.invite = resp.data
      }).catch(error => {
        if (error.response.status == 500) {
          this.$serverErrorModal(error)
          return
        }

        this.$mainDialog.msgBoxOk(error.response.data.message)
      })
  }
}
</script>
